module.exports = __webpack_public_path__ + "static/media/create-home-failed.cc6ec7c0.svg";